var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UploadImage',{attrs:{"url":_vm.uploadUrl,"src":_vm.src,"height":_vm.size,"width":_vm.size,"circle":""},on:{"success":function($event){return _vm.$emit('success')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }